import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Api from "../utils/Api";

const companyContext = createContext(null);

export default function CompanyProvider({ children }) {
    const { user } = useSelector((state) => state.user);
    const [companies, setCompanies] = useState([]);
    const [isLoading, setIsLoading] = useState(false)

    // Fetch companies using the API
    const fetchCompanies = useCallback(async () => {
        try {
            setIsLoading(true);
            const response = await Api.get("/users");
            setCompanies(response.data.data);
        } catch (error) {
            console.error("Failed to fetch companies", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        if (user && user?.role === 'super admin')
            fetchCompanies();
    }, [fetchCompanies, user]);

    return (
        <companyContext.Provider value={{
            companies,
            isLoading,
            fetchCompanies
        }}>
            {children}
        </companyContext.Provider>
    )
}

export const useCompany = () => useContext(companyContext);